export enum Colors {
	Shamrock = 'shamrock',
	Rouge = 'rouge',
	NotMapped = 'not-mapped',
	Mapped = 'mapped',
	All = 'all',
	PreMapped = 'pre-mapped',
	OracleMapped = 'oracle-mapped',
	OracleNotMapped = 'oracle-not-mapped',
	RLOracleMapped = 'rl-oracle-mapped',
	RLOracleNotMapped = 'rl-oracle-not-mapped',
}

export enum TaskStatus {
	Open = 'OPEN',
	InProgress = 'IN_PROGRESS',
	Done = 'COMPLETED',
	Reset = 'RESET',
}

export enum MappedStatus {
	Mapped = 1,
	PreMapped = 2,
	NotMapped = 4,
}

export enum Outlets {
	Primary = 'primary',
	Filters = 'filters',
}

export enum StreamType {
	POS = 'POS',
	Royalty = 'ROYALTY',
	All = 'ALL',
}

export enum OracleStatus {
	Mapped = 'OR_MAPPED',
	NotMapped = 'OR_NOT_MAPPED',
}

/** status filter map constant  */
export const statusFilterMap = {
	[MappedStatus.Mapped]: 'mapped',
	[MappedStatus.NotMapped]: 'notMapped',
	[MappedStatus.PreMapped]: 'preMapped',
};

export enum DragAndDropDataFormat {
	Text = 'plain/text',
	Urls = 'text/uri-list',
}
